import { Card, Checkbox, Col, FormCard } from 'twyne-new.ui'

import InfoTip from '@Components/InfoTip'

import { hasQuestionAnswers } from './QuestionAnswers'
import { templateAlias } from './formUtils'

export default function LivePreview({ type, integrationData, children }) {
  if (!hasQuestionAnswers(type)) {
    return null
  }

  const { question, answers, skipAnswer, skipOption, isMultipleAnswers, consentTextActive, consentText, consentPosition } = integrationData[templateAlias[type]] || {}
  const consent = consentTextActive ? <Consent html={consentText} /> : null

  return <Col size='3' className='sticky top-0 self-start'>
    <FormCard title={<TitleWithTip />} headerButtons={children} classNameBody='max-h-[calc(100vh-200px)] overflow-y-auto'>
      <Card className='flex flex-col gap-4 pointer-events-none'>
        <div dangerouslySetInnerHTML={{ __html: question || '' }} />
        {consentPosition === 'before' ? consent : null}
        <div className='flex flex-col gap-2'>
          {[...answers || [], ...skipOption && skipAnswer ? [skipAnswer] : []].map((answer, index) => <Answer
            key={index}
            answer={answer}
            multiple={isMultipleAnswers}
          />)}
        </div>
        {consentPosition === 'before' ? null : consent}
      </Card>
      <span className='flex justify-center pt-4 text-sm twy-text-neutral'>
        Changes appear here automatically.
      </span>
    </FormCard>
  </Col>
}

function TitleWithTip() {
  return <span className='flex items-center gap-1'>
    Preview
    <InfoTip id='preview' color='neutral'>
      Preview of the content only, not of the published page. It does not apply the page formatting or the theme presets.
    </InfoTip>
  </span>
}

function Answer({ answer, multiple }) {
  return <div
    className='flex items-center gap-2 rounded-xs px-3 py-2'
    style={{ background: `rgba(${answer.color})`, color: `rgba(${answer.fontcolor})` }}
  >
    {multiple ? <Checkbox checked={false} /> : null}
    <span>{answer.answer}</span>
  </div>
}

function Consent({ html }) {
  return <div className='text-sm' dangerouslySetInnerHTML={{ __html: html || '' }} />
}
